<template>
    <v-row class="dialog-wrap" justify="center">
        <v-dialog v-model="dialogShow" persistent max-width="800px">
            <v-card :loading="loading">
                <v-card-title>
                    <span class="text-h5">{{
                        $t("lp.symbolMap.addSymbolMap")
                    }}</span>
                </v-card-title>
                <v-tabs v-model="activeTab">
                    <v-tab v-for="item in baseBatchMaps" :key="item.tabTitle">
                        {{ item.tabTitle }}
                    </v-tab>
                </v-tabs>

                <v-tabs-items v-model="activeTab">
                    <v-tab-item
                        v-for="item in baseBatchMaps"
                        :key="item.tabTitle"
                        eager
                    >
                        <v-form ref="form" v-model="valid">
                            <v-card-text>
                                <v-container>
                                    <v-row>
                                        <v-col cols="12">
                                            <v-text-field
                                                v-if="fromMapPage"
                                                v-model="item.symbol"
                                                :label="
                                                    $t('lp.symbolMap.symbol')
                                                "
                                            />
                                        </v-col>
                                        <v-col cols="12">
                                            <v-text-field
                                                v-model="item.api_code"
                                                :label="
                                                    $t(
                                                        'lp.symbolMap.lpSymbolName'
                                                    )
                                                "
                                                :rules="[rules.required]"
                                            />
                                        </v-col>
                                        <v-col cols="12">
                                            <v-text-field
                                                v-model="item.pk"
                                                :label="
                                                    $t(
                                                        'lp.symbolMap.pkSymbolName'
                                                    )
                                                "
                                                :rules="[rules.required]"
                                            />
                                        </v-col>
                                        <v-col cols="12">
                                            <v-text-field
                                                v-model="item.ratio"
                                                type="number"
                                                :label="
                                                    $t(
                                                        'lp.symbolMap.multiplier'
                                                    )
                                                "
                                                :hide-spin-buttons="true"
                                                :rules="[rules.required]"
                                            />
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                        </v-form>
                    </v-tab-item>
                </v-tabs-items>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="blue darken-1"
                        text
                        @click="dialogShow = false"
                        :loading="loading"
                    >
                        {{ $t("common.form.cancel") }}
                    </v-btn>
                    <v-btn
                        color="blue darken-1"
                        text
                        @click="handleSave"
                        :loading="loading"
                    >
                        {{ $t("common.form.submit") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
import { BatchAddSymbolMap } from "@services/lp/symbol-map";
import { snackbar } from "@components/mixins/snackbar";
import deepClone from "deep-clone";
import { mapState } from "vuex";

export default {
    mixins: [snackbar],
    props: {
        selectedLpId: Number,
        batchMaps: Array, // wait to add maps
    },
    data() {
        return {
            dialogShow: false,
            loading: false,
            baseBatchMaps: [],
            activeTab: 0,
            valid: true,
            rules: {
                required: (value) =>
                    !!value || this.$t("lp.symbolMap.paramRequired"),
                number: (value) =>
                    !/^\d+$/.test(value) ||
                    this.$t("lp.symbolMap.paramMustBeNumber"),
            },
            fromMapPage: false,
        };
    },
    computed: {
        ...mapState("LP", ["lpList"]),
    },
    watch: {
        batchMaps: {
            immediate: true,
            once: true,
            handler(nv) {
                if (nv.length) {
                    this.baseBatchMaps = nv.map((item) => {
                        const symbol = item.split("||")[1];
                        return {
                            tabTitle: item,
                            lp_id: this.lpList.find(
                                (lpData) =>
                                    lpData.lp_name == item.split("||")[0]
                            )?.id,
                            api_code: item.split("||")[1],
                            symbol,
                            pk: item.split("||")[1],
                            ratio: 1,
                        };
                    });
                    this.dialogShow = true;
                }
            },
        },
    },
    methods: {
        open(lpId, lpName) {
            this.baseBatchMaps = [
                {
                    tabTitle: lpName,
                    lp_id: lpId,
                    api_code: "",
                    symbol: "",
                    pk: "",
                    ratio: 1,
                },
            ];
            this.activeTab = 0;
            this.dialogShow = true;
            this.fromMapPage = true;
        },
        async handleSave() {
            this.loading = true;
            const forms = this.$refs.form;
            let allDone = false;
            for (let i = 0, len = forms.length; i < len; i++) {
                if (!forms[i].validate()) {
                    this.activeTab = i;
                    break;
                }
                if (i === len - 1) {
                    allDone = true;
                }
            }
            if (allDone) {
                const params = {
                    symbol_map: deepClone(this.baseBatchMaps),
                };
                params.symbol_map.map((item) => delete item.tabTitle);

                try {
                    const {
                        data: { msg },
                    } = await BatchAddSymbolMap(params);
                    this.successMsg = msg;
                    this.loading = false;
                    this.snackBarSuccess(
                        msg || this.$t("lp.symbolMap.successMsg")
                    );
                    this.dialogShow = false;
                } catch (e) {
                    this.snackBarDanger(
                        e.response?.data?.msg ||
                            this.$t("lp.symbolMap.cantAddMaps")
                    );
                    this.loading = false;
                }
            }
        },
    },
};
</script>
